var render = function render(){var _vm=this,_c=_vm._self._c;return _c('line',{attrs:{"x1":_vm.xScale(_vm.value),"y1":"0","x2":_vm.xScale(_vm.value),"y2":_vm.innerHeight}})
}
var staticRenderFns = []

export { render, staticRenderFns }